import axios from 'axios'
import { REACT_APP_API_ABM_FW } from '../../config'

export async function getRolesLeads() {
    try {
        const response = await axios(REACT_APP_API_ABM_FW + '/roles/leads')
        return response?.data?.data || []
    } catch (e) {
        console.error('Error al obtener roles de gestor de leads', e)
        return []
    }

}
